import { render, staticRenderFns } from "./CampusPicker.vue?vue&type=template&id=7f3433ba&"
import script from "./CampusPicker.vue?vue&type=script&lang=ts&"
export * from "./CampusPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports